import * as React from 'react'
import { useEffect } from 'react'

import { StackChildren, Stack, Text, Spacing } from '@doordash/design-language'
import NavBar from '@doordash/component-navbar'
import { FixedBottomContainer } from '../../atoms/fixed-bottom-container'
import { connect } from 'react-redux'

import styled from 'styled-components'
import { OsTypes } from '../../../webview/types'
import { detectWebviewOs } from '../../../utilities/userAgent'
import {
  IOS,
  ANDROID,
  CLOSE,
  HELP_URL,
  DasherObjectFields,
  BUSY_IMG_URL,
  SCHEDULE_DASH_IMG_URL,
  DASH_IMG_URL,
} from './constants'
import t from './strings'
import { FirstDashButtons, FirstDashContent } from './'
import { loadUrl } from '../../../webview'
import * as actions from '../../../actions'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'
import { get, has } from 'lodash'
import { BusynessStatus } from '../../../models/types'

type FirstDashProps = {
  isSubmarketBusy: boolean
  hasDashNowBenefit: boolean
  loadDasherSerializer?: (fields: string[]) => Promise<void>
  loadStartingPointStatus: () => Promise<void>
  dasher?: {
    rewardsTier?: string
    defaultStartingPoint: number
  }
  startingPointStatus?: object
  track?: (
    name: DA.EventActions,
    page: DA.ActivatedNoFirstDashScreens,
    data?: object
  ) => Promise<void>
}

type ImageContainerProps = {
  url: string
}

const ImageContainer = styled.div`
  height: 35vh;
  width: 100%;
  background-position: 50%;
  background-size: 70%;
  background-image: ${(props: ImageContainerProps) => `url(${props.url})`};
  background-repeat: no-repeat;
`

const ContentContainer = styled.div`
  padding-left: ${Spacing.Small}px;
  padding-right: ${Spacing.Small}px;
`

const FirstDash: React.FC<FirstDashProps> = ({
  loadDasherSerializer,
  loadStartingPointStatus,
  dasher,
  startingPointStatus,
  track,
}) => {
  useEffect(() => {
    loadDasherSerializer([
      DasherObjectFields.RewardsTier,
      DasherObjectFields.DefaultStartingPoint,
    ])
    loadStartingPointStatus()
    track(DA.EventActions.Rendered, DA.ActivatedNoFirstDashScreens.Dash)
  }, [])

  const onClickHelpUrl = () => {
    loadUrl(`${HELP_URL}`)
  }

  const onClose = () => {
    const os = detectWebviewOs()
    const prefix = os === OsTypes.iOS ? IOS : ANDROID
    window.location.assign(`${prefix}${CLOSE}`)
  }
  const hasDashNowBenefit = has(dasher, 'rewardsTier')
  const dasherStartingPoint = get(dasher, 'defaultStartingPoint')

  let isSubmarketBusy = false

  if (startingPointStatus) {
    for (const i in startingPointStatus) {
      if (startingPointStatus[i]) {
        const sp = startingPointStatus[i]
        if (sp.id === dasherStartingPoint) {
          const busynessStatus = sp.vehicle_dash_status[0].busyness_status
          isSubmarketBusy =
            busynessStatus === BusynessStatus.Busy ||
            busynessStatus === BusynessStatus.VeryBusy
          break
        }
      }
    }
  }

  let imgUrl = BUSY_IMG_URL

  if (!isSubmarketBusy) {
    imgUrl = hasDashNowBenefit ? SCHEDULE_DASH_IMG_URL : DASH_IMG_URL
  }

  return (
    <div>
      <NavBar
        onNavigationClick={onClose}
        navigationType={NavBar.NavigationTypes.Close}
        isSeparatorVisible={false}
      />
      <ImageContainer url={imgUrl} />
      <ContentContainer>
        <StackChildren>
          <Text styles={Text.Styles.PageTitle2}>{t.title()}</Text>
          <FirstDashContent
            isSubmarketBusy={isSubmarketBusy}
            hasDashNowBenefit={hasDashNowBenefit}
          />
          <Text
            textDecoration={Text.TextDecorations.Underline}
            weight={Text.Weights.Bold}
            tag={'a'}
            styles={Text.Styles.Medium16}
            onClick={onClickHelpUrl}
          >
            {t.helpCenter()}
          </Text>
        </StackChildren>
      </ContentContainer>
      <FixedBottomContainer>
        <Stack>
          <ContentContainer>
            <FirstDashButtons
              submarketId={dasherStartingPoint}
              isSubmarketBusy={isSubmarketBusy}
              hasDashNowBenefit={hasDashNowBenefit}
              track={track}
            />
          </ContentContainer>
        </Stack>
      </FixedBottomContainer>
    </div>
  )
}

const mapStateToProps = state => ({
  dasher: state.dasher,
  startingPointStatus: state.startingPointStatus,
})

const mapDispatchToProps = {
  loadDasherSerializer: actions.loadDasherSerializer,
  loadStartingPointStatus: actions.loadStartingPointStatus,
  track: events.trackActivatedNoFirstDash,
}

export default connect(mapStateToProps, mapDispatchToProps)(FirstDash)
